/** Display labels. Kept apart from logic so changing a word cannot change behaviour. */
export const CATEGORY_FA: Record<string, string> = {
  cleanser: 'پاک‌کننده',
  toner: 'تونر',
  serum: 'سرم',
  moisturizer: 'مرطوب‌کننده',
  sunscreen: 'ضدآفتاب',
  treatment: 'درمان موضعی',
};

export const PREGNANCY_FA: Record<string, string> = {
  safe: 'ایمن',
  unsafe: 'ناایمن',
  unknown: 'نامشخص',
};

export const REVIEW_FA: Record<string, string> = {
  auto_approved: 'تأیید خودکار',
  pending: 'در انتظار بازبینی',
  approved: 'تأییدشده',
  rejected: 'رد شده',
};

export const STOCK_FA: Record<string, string> = {
  instock: 'موجود',
  outofstock: 'ناموجود',
  onbackorder: 'پیش‌سفارش',
};

export const CONCERN_FA: Record<string, string> = {
  acne: 'آکنه',
  dark_spots: 'لک',
  wrinkles: 'چروک',
  dryness: 'خشکی',
  sensitivity: 'حساسیت',
  large_pores: 'منافذ باز',
};

/**
 * What a product is, read from its own description.
 *
 * Mirrors TRAIT_LABELS_FA in @skinbot/shared, the same way the five maps above
 * mirror their vocabularies: the console has no dependency on the domain
 * package, and a label is display text rather than logic.
 */
export const TRAIT_FA: Record<string, string> = {
  tinted: 'رنگی',
  untinted: 'بی‌رنگ',
  mineral: 'مینرال',
  chemical: 'شیمیایی',
  gel: 'ژلی',
  cream: 'کرمی',
  stick: 'استیکی',
  spray: 'اسپری',
  matte: 'مات',
  dewy: 'براق',
  fragrance_free: 'بدون عطر',
  alcohol_free: 'بدون الکل',
  lightweight: 'سبک',
  rich: 'سنگین',
  waterproof: 'ضد آب',
};

export const SOURCE_FA: Record<string, string> = {
  name_match: 'نام محصول',
  brand_line: 'برند',
  description_llm: 'توضیحات',
  ocr: 'تصویر',
  manual: 'دستی',
};

const toFa = (s: string) => s.replace(/[0-9]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[Number(d)]!);

/*
 * Numbers the way Persian writes them: Persian digits, the Arabic thousands
 * mark (٬) and decimal mark (٫). Intl already knows all of that, so this is one
 * formatter rather than a hand-rolled substitution per call site.
 */
const faWhole = new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 0 });

/** Integer with thousands separators — counts, token totals, quantities. */
export function faInt(value: number): string {
  return Number.isFinite(value) ? faWhole.format(Math.round(value)) : '—';
}

/** One decimal place, for seconds and percentages that need the precision. */
export function faDec(value: number, digits = 1): string {
  if (!Number.isFinite(value)) return '—';
  return new Intl.NumberFormat('fa-IR', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}

/**
 * The store is configured in toman and its API already returns toman, so no
 * conversion. An earlier divide-by-ten here showed every catalog price at one
 * tenth of its real figure.
 */
export function formatPrice(value: string | null): string {
  if (!value) return '—';
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return '—';
  return `${faInt(n)} تومان`;
}

export const faNum = toFa;
